import { BadgeCheck, Shield } from "lucide-react";

export function initials(name) {
  return (name || "?")
    .split(" ")
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

export function MemberBadge({ role, isMember, className = "" }) {
  if (role === "admin") {
    return (
      <span
        data-testid="badge-archivist"
        className={`inline-flex items-center gap-1 font-mono text-[9px] tracking-widest uppercase text-parchment bg-ink px-1.5 py-0.5 ${className}`}
      >
        <Shield strokeWidth={2} className="w-2.5 h-2.5" /> Archivist
      </span>
    );
  }
  if (isMember) {
    return (
      <span
        data-testid="badge-member"
        className={`inline-flex items-center gap-1 font-mono text-[9px] tracking-widest uppercase text-oxblood border border-oxblood px-1.5 py-0.5 ${className}`}
      >
        <BadgeCheck strokeWidth={2} className="w-2.5 h-2.5" /> Member
      </span>
    );
  }
  return null;
}
